import React, { FunctionComponent } from 'react'

import MainLayoutView from './MainLayoutView'

const MainLayout: FunctionComponent = (props) => {
  return <MainLayoutView {...props} />
}

export default MainLayout
